import React from 'react';

import { initialExploreQuery } from '../../helpers/dummyQuery';
import { ExploreAction } from '../../hooks/reducers/exploreReducer';

type ExploreContextT = {
    explore: ExploreQueryT;
    dispatchExplore: React.Dispatch<ExploreAction>;
};

const ExploreContext = React.createContext<ExploreContextT>({
    explore: initialExploreQuery,
    dispatchExplore: () => {},
});

export const useExploreContext = () => React.useContext(ExploreContext);

export default ExploreContext;
